import _ from 'lodash';
import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').Account} Account
 */

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Account} obj.item
 */
export function updateInAccounts (state, obj) {
  const { item, upsert } = obj;
  // find existing
  const existing = state.accounts[item.uid];

  // update existing (inherit patient details)
  if (existing) {
    const { uid, accountConfig, personalDetails, ...details } = item;
    Vue.set(state.accounts, item.uid, {
      ..._.isEmpty(details) ? existing : details,
      uid,
      accountConfig: accountConfig || existing.accountConfig,
      personalDetails: personalDetails || existing.personalDetails
    });
    return;
  }

  // add to list
  if (upsert) Vue.set(state.accounts, item.uid, item);
}
